export default __webpack_public_path__ + "static/media/img-slider-urban-transit-7.58b27980.png";